<template>
  <div class="public-header">
    <div class="public-top">
      <div class="w1200">
        <span class="top-link">
          您好，欢迎来到 <em>广州马帮商城</em>
        </span>
        <ul class="login-regin" v-if="user == null">
          <li class="line">
            <router-link :to="{
              path: '/login',

            }">请登录</router-link>
          </li>
          <li class="line">
            <router-link :to="{
              path: '/register',

            }">免费注册</router-link>
          </li>
          <li>
            商城客服微信电话: 18820057778
          </li>
        </ul>
        <ul class="login-regin" v-else>
          <li class="line">
            {{user.nickname}}
          </li>
          <li>
            <a @click="logout">退出</a>
          </li>
        </ul>
        <ul class="quick_list">
          <li>
            <span class="outline"></span>
            <span class="blank"></span>
            <router-link :to="{
              path: is_login ? '/user/center' : '/login',

            }">
              用户中心
            </router-link>
          </li>
          <li>
            <span class=" outline"></span>
            <span class="blank"></span>
            <a href="#">商家中心<b></b></a>
            <div class="dropdown-menu">
              <ol>
                <li>
                  <router-link :to="{
                    path: '/shop_apply',

                  }">商家入驻</router-link>
                </li>
                <li><a :href="merchant_url">商家登录</a></li>
              </ol>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="header clearfix">
      <div class="w1200">
        <div class="logo">
          <router-link to="/">
            <img src="@/assets/images/logo_2.png">
          </router-link>
        </div>
        <div class="top_search">
          <div class="top_search_box">
            <div id="search">
              <ul class="tab" dstype="Index">
                <el-dropdown size="small" @command="handleSelectSearchType">
                  <span class="el-dropdown-link">
                    {{c_search_type}}<i class="el-icon-arrow-down"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="s_search_type">{{s_search_type}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </ul>
            </div>
            <div class="form_fields">
              <div class="search-form" id="search-form" @click="handleSearch">
                <input placeholder="请输入您要搜索的商品关键字" name="keyword" id="keyword" type="text" class="keyword" value=""
                  maxlength="60">
                <input type="submit" id="button" value="搜索" class="submit">
              </div>
            </div>
          </div>
          <ul class="top_search_keywords">
            <li class="first">热门搜索： </li>
            <li class="first" v-for="(item, index) of keywords" :key="index">
              <a href="javascript:void(0);" @click="toSearchProduct(item.hot_search)">
                {{item.hot_search}}
              </a>
            </li>
          </ul>
        </div>
        <div class="user_menu" @mouseover="getCartList">
          <dl class=" my-cart">
            <dt>
              <span class="ico iconfont"></span>
              购物车
              <i class="arrow"></i>
            </dt>
            <dd>
            <dd>
              <div class="sub-title">
                <h4>最新加入的商品</h4>
              </div>
              <div class="incart-goods-box ps-container">
                <div class="incart-goods">
                  <dl id="cart_item_115" v-for="(item,index) in valid" :key="index">
                    <div v-for="(child, c_index) in item.product_list" :key="c_index">
                      <dt class="goods-name">
                        <a href="javascript:void(0)">{{child.productInfo.store_name}}</a>
                      </dt>
                      <dd class="goods-thumb">
                        <a href="#" title=""><img :src="child.productInfo.image"></a>
                      </dd>
                      <dd class="goods-sales"></dd>
                      <dd class="goods-price">
                        <em>¥{{child.productInfo.price}}×{{child.cart_num}}</em>
                      </dd>
                      <dd class="handle">
                        <em><a href="javascript:void(0);"
                            @click="onDelCartProduct(child.id, index, c_index)">删除</a></em>
                      </dd>
                    </div>
                  </dl>
                </div>
                <div class="ps-scrollbar-x-rail" style="left: 0px; bottom: 3px; width: 348px; display: none;">
                  <div class="ps-scrollbar-x" style="left: 0px; width: 0px;"></div>
                </div>
                <div class="ps-scrollbar-y-rail" style="top: 0px; right: 3px; height: 67px; display: none;">
                  <div class="ps-scrollbar-y" style="top: 0px; height: 0px;"></div>
                </div>
              </div>
              <div class="checkout">
                <span class="total-price">共<i>{{cartCount}}</i>件商品&nbsp;&nbsp;总计金额：<em>¥{{countmoney || 0}}</em></span>

                <a href="javascript:void(0)" class="btn-cart" @click="joinToCart()">结算购物车中的商品</a>

              </div>
            </dd>
            </dd>
            <div class="addcart-goods-num">{{cartCount}}</div>
          </dl>

        </div>
      </div>
    </div>
    <div class="mall_nav">
      <shop-nav v-if="$route.path.search(reg) == -1 "></shop-nav>
      <store-nav v-else></store-nav>
    </div>
    <bread-crumb v-show="$route.path != '/' && $route.path.search(reg) == -1"></bread-crumb>
  </div>
</template>
<script>
  import '@/assets/styles/home_header.css';
  import '@/assets/plugins/jquery.lazyload.min.js'
  import breadCrumb from '@/components/Breadcrumb'
  import ShopNav from '@/components/ShopNav.vue'
  import StoreNav from '@/components/StoreNav.vue'
  import config from '@/utils/config.js';
  import {
    getUserInfo,
    getLogout
  } from '@/api/user.js';
  import {
    getCategory,
    getSearchKeyword,
    getCartCount,
    getCartList,
    postCartDel,
  } from '@/api/store';

  import {
    mul,
    add
  } from '@utils/bc';
  import {
    trim
  } from '@/utils';
  const CHECKED_IDS = 'cart_checked';
  export default {
    name: 'Header',
    props: {
      page: String,
    },
    components: {
      breadCrumb,
      ShopNav,
      StoreNav
    },
    data: function () {
      return {
        reg: '/shop/',
        user: null,
        merchant_url: config.merchant_url,
        c_search_type: '商品',
        s_search_type: '店铺',
        options: {
          mainCell: '.bd ul',
          autoPlay: true,
        },
        category: [],
        cat_id: 1,
        cat_menu_id: 1,
        isGetCategory: false,
        keywords: [],
        cartCount: 0,
        invalid: [],
        valid: [],
        route: '',
        countmoney: 0,
        tcount: 0,
        loading: false
      };
    },
    mounted() {
      var that = this;
      if (that.$route.path == '/') {
        document.getElementsByClassName('mc')[0].style.display = 'block'
      } else {
        document.getElementsByClassName('mc')[0].style.display = 'none'
      }
      if (!localStorage.getItem('category_list')) {
        getCategory()
          .then((res) => {
            that.category = res.data.category_list.slice(0, 15);
            localStorage.setItem('category_list', JSON.stringify(that.category))
            that.setCategory()
          })
          .catch((res) => {
            that.$dialog.error(res.msg);
          });
      } else {
        that.category = JSON.parse(localStorage.getItem('category_list'))
        that.setCategory()
      }
      getSearchKeyword()
        .then((res) => {
          that.keywords = res.data.hot_search.data;
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });

      this.route = this.$route.path;
      if (
        this.$cookie.get('login_status') &&
        this.$cookie.get('login_status') != '' &&
        !this.user
      ) {
        getUserInfo().then((res) => {
          that.is_login = true
          that.user = res.data;
          if (that.user.status && that.user.status == 1) {
            that.getCartList()
          }
        });


      }
    },
    watch: {
      '$route.path': function (newVal, oldVal) {
        var that = this
        if (newVal == '/') {
          this.$nextTick(function () {
            document.getElementsByClassName('mc')[0].style.display = 'block'
            if (
              this.$cookie.get('login_status') &&
              this.$cookie.get('login_status') != '' &&
              !this.user
            ) {
              getUserInfo().then((res) => {
                that.is_login = true
                that.user = res.data;
                if (that.user.status && that.user.status == 1) {
                  that.getCartList()
                }
              });

            }
          })
        } else {
          this.$nextTick(function () {
            document.getElementsByClassName('mc')[0].style.display = 'none'
          })
        }
      }
    },
    methods: {
      joinToCart() {
        if (this.is_login && this.user) {
          if (this.user.status == 1) {
            this.$router.push('/cart')
          } else {
            this.$dialog.error('请联系管理员审核')
          }
        } else {
          this.$router.push('/login')
        }
      },
      setCategory() {
        var that = this
        this.$nextTick(function () {
          var index = 1;
          $(function () {
            //首页左侧分类菜单
            $(".all_categorys ul.menu").find("li").each(
              function () {
                var addClass = 'category-ico-' + index;
                $(this)
                  .find('span')
                  .addClass(addClass);
                index++;
                $(this).hover(
                  function () {
                    var cat_id = $(this).attr("cat_id");
                    var menu = $(this).find("div[cat_menu_id='" + cat_id + "']");
                    menu.show();
                    $(this).addClass("hover");
                    var menu_height = menu.height();
                    if (menu_height < 60) menu.height(80);
                    menu_height = menu.height();
                    var li_top = $(this).position().top;
                    $(menu).css("top", -li_top + 40);
                  },
                  function () {
                    $(this).removeClass("hover");
                    var cat_id = $(this).attr("cat_id");
                    $(this).find("div[cat_menu_id='" + cat_id + "']").hide();
                  }
                );
              }
            );

            $(".user_menu dl").hover(function () {
              $(this).addClass("hover");
            }, function () {
              $(this).removeClass("hover");
            });

            $('.user_menu .my-mall').mouseover(function () {
              // 最近浏览的商品
              $(this).unbind('mouseover');
            });
            $('.user_menu .my-cart').mouseover(function () {
              // 运行加载购物车
              if (that.is_login || that.user) {
                if (that.user.status && that.user.status == 1) {
                  that.getCartList()
                }
              }
              $(this).unbind('mouseover');
            });
            //懒加载
            $("img.lazyload").lazyload({
              effect: "fadeIn",
              skip_invisible: false,
              threshold: 200,
            });
          });
        })
      },
      //总共价钱；
      countMoney: function () {
        let that = this;
        let carmoney = 0;
        let array = that.valid;
        for (let i = 0; i < array.length; i++) {
          let list = array[i].product_list;
          for (let j = 0; j < list.length; j++) {
            carmoney = add(carmoney, mul(list[j].cart_num, list[j].truePrice));
          }
        }

        that.countmoney = carmoney;
      },
      //数量
      carnum: function () {
        let that = this;
        var carnum = 0;
        var array = that.valid;
        for (let i = 0; i < array.length; i++) {
          let list = array[i].product_list;
          for (let j = 0; j < list.length; j++) {
            carnum += parseInt(list[j].cart_num);
          }
        }
        that.cartCount = carnum;
      },
      // //获取数量
      gainCount: function () {
        let that = this;
        getCartCount().then((res) => {
          that.count = res.data.count;
        });
      },
      // 删除购物车的产品
      onDelCartProduct(id, index, c_index) {
        var that = this;
        this.$dialog.confirm({
          mes: '确认要删除此商品吗?',
          opts: () => {
            postCartDel(id).then(function () {
              that.$dialog.success('删除成功');
              that.getCartList();
            });
          },
        });
      },
      // 登出
      logout: function () {
        var that = this;
        this.$confirm('确认退出登录?', '提示', {
            center: 'true',
          })
          .then(() => {
            getLogout()
              .then((res) => {
                that.$store.commit('LOGOUT');
                location.href = location.origin;
                that.$router.go(0);
                this.$dialog.toast({
                  mes: '退出成功'
                });
              })
              .catch((err) => {});
          })
          .catch(() => {
            that.$dialog.error(res.msg);
          });
      },
      getCartList: function () {
        let that = this;
        if (that.loading) return;
        if (!that.user || !that.user.status) return;
        if (that.user.status && that.user.status == 0) return;
        that.loading = true;
        that.product_list = 0;
        getCartList().then((res) => {
          that.invalid = res.data.invalid;
          that.valid = res.data.valid;
          let checkedIds = this.$cookie.get(CHECKED_IDS) || [];
          if (!Array.isArray(checkedIds)) checkedIds = [];
          that.loading = false;
          this.valid.forEach((cart) => {
            cart.product_list.forEach((item) => {
              that.count++;
              if (checkedIds.indexOf(item.id) !== -1) item.checked = true;
              that.product_list++;
            });
          });
          if (checkedIds.length) {
            that.checkedIds = checkedIds;
            that.carnum();
            that.countMoney();
            that.gainCount()
          }
          this.loaded = true;
        });
      },
      handleSearch(e) {
        const search = trim($('#keyword').val()) || '';
        if (!search) {
          return;
        }
        if (this.c_search_type == '商品') {
          this.toSearchProduct(search);
        } else if (this.c_search_type == '店铺') {
          this.toSearchStore(search);
        }


      },
      toSearchStore(s) {
        this.$router.push({
          path: '/shop_street',
          query: {
            s: s
          }
        });
      },
      toSearchProduct(s) {
        this.$router.push({
          path: '/good/list',
          query: {
            s: s,
            type: 1
          }
        });
      },
      handleSelectSearchType(command) {
        this.c_search_type = command;
        if (command == '店铺') {
          this.s_search_type = '商品';
        } else {
          this.s_search_type = '店铺';
        }
      },
    },
  };
</script>

<style scoped>
  .mall_nav {
    border-bottom: none;
  }

  .mall_nav .all_categorys .mc {
    display: none;
  }

  .right-sidebar {
    z-index: 999;
  }

  .logo {
    padding: 0 50px;
  }

  .logo img {
    width: 120px;
  }

  .header .user_menu {
    margin-top: 30px;
  }

  .header .top_search {
    margin: 30px 0 0 20px;
    width: 600px;
  }

  .el-dropdown-link {
    cursor: pointer;
  }

  .el-icon-arrow-down {
    font-size: 10px;
  }

  .header .top_search_box ul {
    text-align: center;
    text-indent: 0%;
  }
</style>
